import { render, staticRenderFns } from "./speech-template.vue?vue&type=template&id=2083edf3&scoped=true"
import script from "./speech-template.vue?vue&type=script&lang=ts"
export * from "./speech-template.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2083edf3",
  null
  
)

export default component.exports